<template>
  <div class="login">
    <div class="my-flex my-item-center systemName">
      <img v-if="+$db.get('Hide_Company_Info') !== 1" src="../../../static/img/icon1.png" style="width: 40px;height: 40px"/>
      <span :style="{'margin-left': +$db.get('Hide_Company_Info') === 1 ? '' : '20px'}">{{ +$db.get('Hide_Company_Info') === 1 ? '' : 'AC-' }}IMCMS</span>
    </div>
    <div>
      <a-form @submit.prevent="doLogin" :form="form">
        <a-alert
          type="error"
          :closable="true"
          v-show="error"
          :message="error"
          showIcon
          style="margin-bottom: 24px"
        ></a-alert>
        <a-form-item style="display: flex;align-item: center;justify-content: center;">
          <a-input
            style="width: 280px;"
            size="large"
            :placeholder="$t('login.account')"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: accountMsg, whitespace: true },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="user"></a-icon>
          </a-input>
        </a-form-item>
        <a-form-item style="display: flex;align-item: center;justify-content: center;">
          <a-input-password
            style="width: 280px;"
            size="large"
            type="password"
            :placeholder="$t('login.password')"
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: passwordMsg, whitespace: true },
                ],
              },
            ]"
          >
            <a-icon slot="prefix" type="lock"></a-icon>
          </a-input-password>
        </a-form-item>
        <a-form-item style="display: flex;align-item: center;justify-content: center;">
          <a-button
            :loading="loading"
            style="width: 280px; margin-top: 20px"
            size="large"
            htmlType="submit"
            type="primary"
          >
            {{$t("login.login")}}
          </a-button>
        </a-form-item>
        <div style="width: 280px;display: flex;align-items: center;justify-content: space-between;">
          <div style="color: #ffffff;padding-left: 40px;">
            <a-checkbox-group @change="onChange">
              <a-row>
                <a-col :span="12">
                  <!--
                  <a-checkbox value="A" style="color: #1890FF;font-size: 10px">
                    {{$t("login.remember_password")}}
                  </a-checkbox>
                  -->
                </a-col>
                <a-col :span="12">
                  <!--
                  <a-checkbox value="B" style="color: #1890FF;font-size: 10px">
                    {{$t("login.anonymous_login")}}
                  </a-checkbox>
                  -->
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>

          <a-popover>
            <template slot="content">
              <div style="font-size: 10px;font-weight:400;">
                <div>
                  <a-icon type="exclamation-circle" theme="filled" style="color: #FAAD14" />
                  <span>{{$t("login.contact_us")}}</span>
                </div>
                <!-- <div style="padding-left: 20px;">
                  <span>{{$t("login.contact_tel")}}:</span>
                  <span style="color: #1890FF">13564984916</span>
                </div> -->
                <!-- <a-button style="margin-top: 10px" type="primary">确认</a-button> -->
              </div>
            </template>
            <a style="color: #1890FF;font-size: 10px;">{{$t("login.forgot_password")}}</a>
          </a-popover>
        </div>
      </a-form>
    </div>
    <!-- 18n -->
    <i18n-selector />
    <global-footer :copyright="copyright" :copyno="copyno" class="footer" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import I18nSelector from '../common/i18nSelector'
import GlobalFooter from '../../views/common/GlobalFooter.vue'
export default {
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  name: 'Login',
  components: { I18nSelector, GlobalFooter },
  data () {
    return {
      loading: false,
      error: '',
      activeKey: '1',
      dicts: [],
      accountMsg: this.$t('login.enter_account'),
      passwordMsg: this.$t('login.enter_password')
    }
  },
  computed: {
    systemName () {
      if (this.$db.get('language') === 'zh-cn') {
        return this.$store.state.setting.systemName
      } else {
        return this.$store.state.setting.systemNameEn
      }
    },
    copyright () {
      if (this.$db.get('language') === 'zh-cn') {
        return this.$store.state.setting.copyright
      } else {
        return this.$store.state.setting.copyrightEn
      }
    },
    copyno () {
      if (this.$db.get('language') === 'zh-cn') {
        return this.$store.state.setting.copyno
      } else {
        return this.$store.state.setting.copynoEn
      }
    }
  },
  created () {
    let language = this.$db.get('language') || 'zh-cn'
    this.$db.clear()
    this.$router.options.routes = []
    this.$db.save('language', language)
    this.$i18n.locale = language
    // console.log(JSON.parse(localStorage.getItem('sspassword')))
  },
  methods: {
    doLogin () {
      if (this.activeKey === '1') {
        // 用户名密码登录
        this.form.validateFields(['name', 'password'], (errors, values) => {
          if (!errors) {
            this.loading = true
            let name = this.form.getFieldValue('name')
            let password = this.form.getFieldValue('password')
            this.$post('login', {
              username: name,
              password: this.$aesEncrypt.encrypt(password)
            })
              .then((r) => {
                localStorage.setItem('sspassword', this.$aesEncrypt.encrypt(password))
                let data = r.data.data
                this.saveLoginData(data)
                setTimeout(() => {
                  this.loading = false
                }, 500)
                this.getDicts()
                this.$router.push('/')
              })
              .catch((e) => {
                console.error(e)
                setTimeout(() => {
                  this.loading = false
                }, 500)
              })
          }
        })
      }
      if (this.activeKey === '2') {
        // 手机验证码登录
        this.$message.warning('暂未开发')
      }
    },
    regist () {
      this.$emit('regist', 'Regist')
    },
    getCaptcha () {
      this.$message.warning('暂未开发')
    },
    handleTabsChange (val) {
      this.activeKey = val
    },
    ...mapMutations({
      setToken: 'account/setToken',
      setExpireTime: 'account/setExpireTime',
      setPermissions: 'account/setPermissions',
      setRoles: 'account/setRoles',
      setUser: 'account/setUser',
      setHospital: 'account/setHospital',
      setTheme: 'setting/setTheme',
      setLayout: 'setting/setLayout',
      setMultipage: 'setting/setMultipage',
      fixSiderbar: 'setting/fixSiderbar',
      fixHeader: 'setting/fixHeader',
      setColor: 'setting/setColor',
      setDicts: 'dict/setDicts'
    }),
    saveLoginData (data) {
      this.setToken(data.token)
      this.setExpireTime(data.exipreTime)
      this.setUser({...data.user, hospitalName: data.hospital.name})
      if (data.hospital) {
        this.setHospital(data.hospital.uuid)
      }
      this.setPermissions(data.permissions)
      this.setRoles(data.roles)
      this.setTheme(data.config.theme)
      this.setLayout(data.config.layout)
      this.setMultipage(data.config.multiPage === '1')
      this.fixSiderbar(data.config.fixSiderbar === '1')
      this.fixHeader(data.config.fixHeader === '1')
      this.setColor(data.config.color)
    },
    getDicts () {
      this.$get('dict/trim')
        .then((r) => {
          let data = r.data
          this.saveDictData(data)
        })
        .catch((e) => {
          console.error(e)
        })
    },
    saveDictData (data) {
      this.setDicts(data)
    },
    onChange () {}
  }
}
</script>

<style lang="less" scoped>
.login {

  padding: 50px 20px 50px 20px;
  margin: 20px 10px;
  // position: absolute;
  display: flex;
  flex-direction: column;
  align-self: center;
  background: linear-gradient(161.31deg, rgba(5, 31, 91, 0.5) 7.74%, rgba(5, 31, 91, 0.5) 87.36%);
  box-shadow: 0px 2px 10px rgba(225, 225, 225, 0.05), 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  .systemName {
    margin: 0 40px 20px 40px;
    font-size: 24px;
    font-weight: 600;
    line-height: 34px;
    letter-spacing: 0em;
    text-align: center;
    color: #fff;
    // margin-bottom: 40px;
  }
  .welcome {
    font-size: 32px;
    font-weight: 500;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: left;
    // color: #ffffff;
  }
  .icon {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
    margin-left: 16px;
    vertical-align: middle;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #1890ff;
    }
  }
}
/deep/ .ant-input-prefix {
  color: #fff !important;
}
/deep/ .ant-input {
  color: rgba(255, 255, 255, 0.2) !important;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  &::placeholder {
    color: #fff;
  }
}
/deep/ .ant-input-password-icon {
  color: #fff;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: transparent;
  color: #fff;
  left: 0;
  i {
    font-size: .8rem !important;
  }
  /deep/  a, /deep/ .copyright {
    color: #fff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/Login.vue